module.exports = __webpack_public_path__ + "static/media/viewAuditTrailGuide2_Jap.0eeb3ab7.png";